import * as z from 'zod';

export const RaceItemCrewSchema = z.object({
  id: z.string(),
  raceItemId: z.string(),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  consentFormParticipantDateOfBirth: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParticipantPronouns: z.string().nullish(),
  consentFormParticipantAddress: z.string().nullish(),
  consentFormParentCarerFirstName: z.string().nullish(),
  consentFormParentCarerSurname: z.string().nullish(),
  consentFormParentCarerAddress: z.string().nullish(),
  consentFormParentCarerRelationship: z.string().nullish(),
  consentFormParentCarerContactNumber: z.string().nullish(),
  consentFormEmergencyContact1Name: z.string().nullish(),
  consentFormEmergencyContact1Relationship: z.string().nullish(),
  consentFormEmergencyContact1Phone: z.string().nullish(),
  consentFormEmergencyContact2Name: z.string().nullish(),
  consentFormEmergencyContact2Relationship: z.string().nullish(),
  consentFormEmergencyContact2Phone: z.string().nullish(),
  consentFormImportantMedicalInformation: z.string().nullish(),
  consentFormMedicationDetails: z.string().nullish(),
  consentFormInjuriesDetails: z.string().nullish(),
  consentFormDietaryRequirementsDetails: z.string().nullish(),
  consentFormDisabilityDetails: z.string().nullish(),
  consentFormCodeOfConductAccepted: z.boolean().nullish(),
  codeOfConductConsentedAt: z.coerce.date().nullish(),
  photoConsent: z.boolean().nullish(),
  photoConsentedAt: z.coerce.date().nullish(),
  marketingConsent: z.boolean().nullish(),
  marketingConsentedAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string().nullish(),
  dataProcessingConsent: z.boolean().nullish(),
  dataProcessingConsentedAt: z.coerce.date().nullish(),
  emergencyTreatmentConsent: z.boolean().nullish(),
  emergencyTreatmentConsentedAt: z.coerce.date().nullish(),
});

export type RaceItemCrewType = z.infer<typeof RaceItemCrewSchema>;
